import { render, staticRenderFns } from "./proceso_merma.vue?vue&type=template&id=4055b698&scoped=true&"
import script from "./proceso_merma.vue?vue&type=script&lang=ts&"
export * from "./proceso_merma.vue?vue&type=script&lang=ts&"
import style0 from "./proceso_merma.vue?vue&type=style&index=0&id=4055b698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055b698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
